import type { AssetCategory, MarketBrief, MarketingScript, NewsItem } from '@/types';

export const ASSET_CATEGORIES: AssetCategory[] = [
  '宏观经济',
  '股市',
  '债市',
  '基金',
  '理财',
  '保险',
  '贵金属',
];

export const TODAY_BRIEF: MarketBrief = {
  date: '2026-08-17',
  headline: '黄金强势突破4444美元历史关口，避险情绪主导全球市场',
  overview:
    '今日市场焦点高度集中于贵金属板块——国际黄金现货价格盘中突破4444美元/盎司，再创历史新高，国内金价同步冲破1030元/克。A股在外围不确定性加剧下小幅震荡，北向资金维持净流入；债市收益率窄幅波动，资金面平稳；银行理财规模稳步扩张。理财经理今日核心任务：主动触达持有或关注黄金产品的客户，做好行情解读与配置建议。',
  keyTakeaways: [
    '黄金现货突破4444美元/盎司历史关口，国内金价升至约1030元/克，涨幅约2.3%',
    '央行超量续作MLF，释放流动性呵护信号，资金面压力暂缓',
    'A股成交量维持低位，主力资金净流入科技板块逾18亿',
    '十年期国债收益率下行2bp至2.24%，债市短线风险可控',
    '公募基金规模突破32万亿，被动型ETF持续获资金青睐',
    '保险资金二季报显示权益仓位创近四年新高，险资入市信号积极',
    '银行理财规模续升至29.4万亿，收益率中枢维持2.7%-2.9%区间',
  ],
  assetSummaries: [
    {
      category: '宏观经济',
      sentiment: 'positive',
      keyPoint: '政策暖风频吹，稳增长基调明确',
      recommendation: '关注政策落地节奏，向客户传递经济复苏信心',
      change: '偏多',
    },
    {
      category: '股市',
      sentiment: 'neutral',
      keyPoint: 'A股震荡筑底，科技板块资金流入',
      recommendation: '建议持仓客户耐心等待，布局优质宽基ETF',
      change: '+0.32%',
    },
    {
      category: '债市',
      sentiment: 'positive',
      keyPoint: '资金面宽松，长端利率回落',
      recommendation: '短期债基配置价值提升，适合稳健型客户',
      change: '-2bp',
    },
    {
      category: '基金',
      sentiment: 'positive',
      keyPoint: '新发基金规模回升，ETF持续获资',
      recommendation: '推荐宽基指数ETF定投，分享市场β收益',
      change: '+4.1%',
    },
    {
      category: '理财',
      sentiment: 'neutral',
      keyPoint: '收益率中枢稳定，规模持续扩张',
      recommendation: '到期客户可优先续作3-6个月固收产品',
      change: '2.75%年化',
    },
    {
      category: '保险',
      sentiment: 'positive',
      keyPoint: '险资权益仓位创新高，配置意愿增强',
      recommendation: '向高净值客户介绍增额终身寿险长期锁利价值',
      change: '利好',
    },
    {
      category: '贵金属',
      sentiment: 'positive',
      keyPoint: '黄金突破4444美元历史关口，避险需求爆发',
      recommendation: '主动触达客户，推荐黄金积存、纸黄金及黄金ETF',
      change: '+2.3%',
    },
  ],
};

export const NEWS_ITEMS: NewsItem[] = [
  {
    id: '1',
    title: '央行超量续作MLF 8000亿，向市场释放流动性呵护信号',
    summary: '央行以8000亿超量续作MLF，利率持平，显示宽松基调延续，短期资金面压力缓解。',
    category: '宏观经济',
    source: '中国人民银行',
    publishedAt: '2026-08-16T07:45:00Z',
    sentiment: 'positive',
    content:
      '中国人民银行今日开展8000亿元中期借贷便利（MLF）操作，到期量为5000亿元，实现净投放3000亿元，操作利率持平于2.5%。此举被市场解读为货币政策维持宽松基调、呵护年末流动性的重要信号。分析人士指出，超量续作MLF有助于稳定市场预期，同时为下一步降准、降息预留空间。机构普遍预计四季度资金面将维持合理宽裕，十年期国债收益率有望维持低位震荡。',
  },
  {
    id: '2',
    title: '中央经济工作会议精神传达：明年稳增长置于首位，财政政策加力提效',
    summary: '会议明确稳增长为首要任务，财政赤字率或提升至3.5%，基建投资力度持续加大。',
    category: '宏观经济',
    source: '新华社',
    publishedAt: '2026-08-16T06:30:00Z',
    sentiment: 'positive',
    content:
      '中央经济工作会议明确将稳增长置于明年经济工作首要目标，强调"积极的财政政策要加力提效"，市场预期明年财政赤字率将提升至3.5%左右，专项债规模进一步扩大。会议还提出加大对消费的支持力度，推动大规模设备更新和消费品以旧换新，有望带动内需明显改善。分析人士认为，这一信号对于权益市场中期表现具有较强支撑意义。',
  },
  {
    id: '3',
    title: 'A股三大指数集体收涨，北向资金净买入52亿扭转连续净流出',
    summary: '沪深300涨0.32%，北向资金净买入52亿创近期新高，科技医药板块领涨。',
    category: '股市',
    source: '上海证券交易所',
    publishedAt: '2026-08-16T09:35:00Z',
    sentiment: 'positive',
    content:
      '今日A股三大指数集体收涨，上证综指涨0.28%，深证成指涨0.45%，创业板指涨0.67%。北向资金时隔三日重现净流入，全天净买入52亿元，主要流向科技（约18亿）、医药（约12亿）板块。市场成交量虽仍处低位，但技术形态显示短期筑底信号增强。机构分析认为，政策预期改善叠加外资回流是今日上涨的核心驱动因素。',
  },
  {
    id: '4',
    title: '美联储会议纪要偏鹰，外资阶段性减持新兴市场资产',
    summary: '美联储纪要显示降息不急，引发外资短线流出亚太市场，A股承压但幅度有限。',
    category: '股市',
    source: '路透社',
    publishedAt: '2026-08-15T22:10:00Z',
    sentiment: 'negative',
    content:
      '美联储最新会议纪要显示，多名官员认为当前利率水平仍具限制性，短期内不急于降息，引发全球风险资产情绪波动。亚太股市普遍承压，韩国、台湾市场跌幅超1%。A股虽受外围拖累，但在内资托底下跌幅相对有限。分析人士建议理财经理向持有海外资产的客户做好预期管理，避免恐慌性赎回。',
  },
  {
    id: '5',
    title: '十年期国债收益率降至2.24%，债市情绪回暖',
    summary: '受MLF超量续作提振，十年期国债收益率下行2bp至2.24%，债市短线趋于平稳。',
    category: '债市',
    source: '中国债券信息网',
    publishedAt: '2026-08-16T10:00:00Z',
    sentiment: 'positive',
    content:
      '今日债券市场整体回暖，十年期国债活跃券收益率较上日下行2个基点至2.24%，创近两周新低。受央行超量续作MLF影响，资金面边际宽松，隔夜利率小幅回落至1.72%。机构配置需求有所回升，农商行等中小行买盘积极。分析人士认为，在稳增长政策背景下，债市下行空间仍有，但幅度或有限，适合配置中短期产品。',
  },
  {
    id: '6',
    title: '信用债市场分化：城投债需求旺盛，房企债流动性仍待改善',
    summary: '城投债认购倍数普遍超3倍，而部分房企中票成交稀少，信用市场分化持续。',
    category: '债市',
    source: '中国证券报',
    publishedAt: '2026-08-16T08:20:00Z',
    sentiment: 'neutral',
    content:
      '今日信用债一级市场显示出明显的结构分化特征。多支城投债认购倍数超过3倍，显示出市场对政策兜底逻辑的高度认可；而部分房地产企业中期票据的询价机构寥寥，显示房企信用修复之路仍然漫长。业内人士建议在信用债配置中坚持"优质城投+高等级产业债"策略，回避弱资质主体风险。',
  },
  {
    id: '7',
    title: '公募基金规模突破32万亿，股票ETF单月净申购创年内新高',
    summary: '9月公募总规模达32.1万亿，股票ETF净申购超1200亿，被动投资趋势强化。',
    category: '基金',
    source: '中国基金报',
    publishedAt: '2026-08-16T07:00:00Z',
    sentiment: 'positive',
    content:
      '据最新数据，公募基金管理总规模突破32万亿元，创历史新高。其中股票型ETF单月净申购超1200亿元，为年内最高单月净申购记录，宽基ETF（如沪深300ETF、中证500ETF）是资金主要流向。主动权益基金申购赎回基本平衡，显示市场情绪趋于稳定。分析人士指出，ETF规模持续扩张将进一步增强指数化投资对市场的托底效应。',
  },
  {
    id: '8',
    title: '权益基金业绩分化明显，主动基金经理Alpha获取难度增加',
    summary: '前三季度主动权益基金中位数回报-4.2%，跑赢沪深300的基金不足三成。',
    category: '基金',
    source: '证券时报',
    publishedAt: '2026-08-15T16:30:00Z',
    sentiment: 'neutral',
    content:
      '今年前三季度，主动权益基金整体表现不及预期，业绩中位数约为-4.2%，跑赢沪深300指数的基金比例不足三成。市场高度不确定性下，主动基金经理的Alpha获取难度明显上升。相比之下，被动指数型基金以低费率、透明化的特点吸引资金持续流入。分析人士建议理财经理在基金推荐中，对主动与被动产品的配置比例进行合理规划。',
  },
  {
    id: '9',
    title: '银行理财规模续升至29.4万亿，现金管理类产品监管趋严',
    summary: '银行理财规模持续回升，但监管趋严下现金管理类产品收益或承压。',
    category: '理财',
    source: '银行业理财登记托管中心',
    publishedAt: '2026-08-16T09:00:00Z',
    sentiment: 'neutral',
    content:
      '据银行业理财登记托管中心数据，截至上月末银行理财存续规模达29.4万亿元，较年初增加约2万亿元。固定收益类产品占比超过95%，平均7日年化收益率维持在2.7%-2.9%区间。值得关注的是，监管部门近期就现金管理类理财产品的投资范围及杠杆比例出台新规，预计相关产品收益率将有所下调，理财经理需向存量客户提前做好沟通。',
  },
  {
    id: '10',
    title: '保险资金二季报：权益仓位达14.8%，创近四年新高',
    summary: '险资权益仓位升至14.8%，增配红利股和优质ETF，入市信号积极明确。',
    category: '保险',
    source: '国家金融监督管理总局',
    publishedAt: '2026-08-15T18:00:00Z',
    sentiment: 'positive',
    content:
      '国家金融监督管理总局披露数据显示，保险资金二季度末权益类资产配置比例升至14.8%，创2022年以来新高。增配方向主要集中在高股息红利股（银行、能源、公用事业）及宽基ETF，体现险资在低利率环境下追求稳健绝对回报的策略。分析人士认为，险资大规模入市将为A股提供长期资金支撑，有助于修复市场风险偏好。对理财经理而言，这也是向客户讲解权益市场长期配置逻辑的重要论据。',
  },
  {
    id: '11',
    title: '黄金现货强势突破4444美元历史关口，国内金价升破1030元/克',
    summary: '黄金突破4444美元/盎司历史新高，国内金价升至约1030元/克，涨幅约2.3%，多空分歧加剧。',
    category: '贵金属',
    source: '世界黄金协会',
    publishedAt: '2026-08-17T09:30:00Z',
    sentiment: 'positive',
    content:
      '国际黄金现货价格今日盘中强势突破4444美元/盎司，创历史新高，日内涨幅约2.3%。驱动因素多重叠加：美联储降息预期再度升温、中东地缘局势持续紧张、全球央行购金需求居高不下，以及美元指数走弱带来的配置需求切换。国内黄金价格同步冲高，每克价格突破1030元，再度刷新纪录。分析人士指出，4444美元是重要心理关口，短线突破后空间进一步打开，但高位波动风险亦不容忽视，建议客户分批布局而非追高。理财经理应主动向客户介绍黄金积存计划、纸黄金及黄金ETF等配置工具，并做好"高位买入"的预期管理。',
  },
  {
    id: '12',
    title: '金银比收窄至83倍，白银跟涨加速，贵金属板块全线走强',
    summary: '金银比从88收窄至83倍，白银跟涨节奏加快，贵金属整体配置价值凸显。',
    category: '贵金属',
    source: '彭博社',
    publishedAt: '2026-08-17T08:00:00Z',
    sentiment: 'positive',
    content:
      '随着黄金突破4444美元，白银价格也加速跟涨，金银比价从近期高点88倍收窄至约83倍，显示市场风险偏好正在向贵金属板块全面倾斜。分析人士指出，历史上金银比从高位快速收窄，往往意味着白银进入补涨阶段，弹性或超过黄金。对于配置了黄金积存或纸黄金的客户，理财经理建议继续持有；对已持有白银产品的客户，可适度保留仓位，等待补涨行情兑现。',
  },
];

export const SCRIPTS: MarketingScript[] = [
  {
    id: 's1',
    title: '黄金破4444美元，客户询问还能追吗',
    scenario: '客户看到黄金突破4444美元历史新高，主动询问现在买入是否太晚',
    category: '贵金属',
    script:
      '您关注得非常及时！黄金今天确实突破了4444美元这个重要的历史关口，创下历史新高。很多客户都有同样的疑问：涨了这么多还能买吗？我的看法是：从驱动逻辑来看，全球央行持续大规模购金、美联储降息周期开启、地缘政治局势持续紧张，这些因素短期内不会消失，黄金的中期上行趋势是清晰的。但站在4444美元这个高位，短线获利回吐的风险也不能忽视。所以我的建议不是"该不该买"，而是"怎么买"——不要一次性追高，建议分两到三批建仓，或者通过黄金积存计划每月定额投入，把平均成本平滑下来。您目前在贵金属方向上已经有配置了吗？我们可以根据您的整体资产结构，算一个合理的仓位比例。',
    keyPoints: ['正面回应"追高"顾虑，不回避', '强调中期驱动逻辑仍在', '建议分批建仓而非一次性追高', '了解现有配置，给出个性化比例建议'],
  },
  {
    id: 's2',
    title: '债基波动，持仓客户安抚',
    scenario: '债券基金近期回调，持仓客户表示担忧，询问是否赎回',
    category: '债市',
    script:
      '您好，感谢您第一时间联系我。债市最近确实有些波动，主要是受到资金面阶段性偏紧的影响。但我需要告诉您，债券基金本质上是通过利息收入积累回报的，短期净值波动是正常现象，不代表持有的债券出现了实质性风险。从历史数据来看，纯债基金持有超过6个月的正收益概率超过95%。您当初购买的这只产品，主要配置的是利率债和高等级信用债，整体资产质量是有保障的。我建议您继续持有，避免在波动时赎回锁定损失。如果您资金暂时不急用，这个位置反而可以考虑适当加仓摊低成本。',
    keyPoints: ['解释波动原因，消除恐慌', '用历史数据增强信心', '建议持有甚至加仓，抓住机会'],
  },
  {
    id: 's3',
    title: '宽基ETF定投推荐话术',
    scenario: '向对A股有顾虑但有长期投资意愿的客户推荐指数定投',
    category: '基金',
    script:
      '我理解您对A股的顾虑，波动大、选股难是很多人的共同感受。其实有一个非常简单的方法可以解决这个问题——定投宽基指数ETF。简单说就是每个月固定投入一笔钱，买沪深300或中证500这样的指数，不用自己选股，跟着整个市场走。市场跌的时候，您买到的份额更多；涨的时候，自然获益。机构测算显示，连续定投沪深300指数满3年，历史上正收益概率超过80%。现在公募基金规模突破32万亿，大资金也在通过ETF持续入市，这是市场趋势所在。您每个月有多少闲置资金可以用于这个方向呢？',
    keyPoints: ['用"不用选股"降低决策难度', '强调定投分散风险的逻辑', '用历史概率数据增加说服力', '引导客户说出可投金额'],
  },
  {
    id: 's4',
    title: '理财到期续作，推荐固收产品',
    scenario: '客户理财产品即将到期，需要沟通续作方向',
    category: '理财',
    script:
      '您好，您名下有一笔理财产品下周到期，我特地联系您提前做个安排。目前市场上固收类产品收益率在2.7%-3.0%之间，保持相对稳定。考虑到您偏稳健的风险偏好，我为您准备了两个方向：一是继续续作同类理财，期限3个月，预期收益率2.8%；二是配置一只中短期纯债基金，流动性稍强，历史年化回报在3%左右，但净值有小幅波动。如果近期没有大额用钱计划，固收基金可能是更好的选择。您方便告诉我最近3个月有没有资金使用需求吗？',
    keyPoints: ['主动出击，提前联系，体现专业', '提供两套方案，让客户有选择感', '了解流动性需求，个性化推荐'],
  },
  {
    id: 's5',
    title: '股市低迷期间维护客户关系',
    scenario: 'A股持续震荡，权益产品持仓客户久未联系，需主动维护',
    category: '股市',
    script:
      '您好，最近市场比较平静，我想主动联系您做个资产回顾。这段时间A股整体在筑底阶段，波动比较大，但我注意到您持仓的这只基金，在同类产品里表现排名靠前，基金经理在低位做了一些很聪明的布局调整。市场低迷的时候往往是长线布局的好时机——历史上每一次A股筑底，之后都会有一轮可观的修复行情。当然，时间是最大的成本，不一定要您现在加仓，但至少我们先了解一下您的整体配置情况，看看有没有需要调整的地方，如何？',
    keyPoints: ['主动联系体现责任心，不是等客户投诉', '肯定持仓产品，稳定情绪', '用历史规律讲长期逻辑', '不强推，以关系维护为主'],
  },
  {
    id: 's6',
    title: '高净值客户增额终身寿配置',
    scenario: '向有资产传承或长期锁利需求的高净值客户介绍保险产品',
    category: '保险',
    script:
      '李总，跟您报告一个市场动态：现在利率下行趋势比较明确，未来的理财、存款收益率大概率还会继续走低。在这个背景下，越来越多高净值客户选择把一部分资产配置到增额终身寿险——它的核心价值是锁定当前3%以上的长期复利，不受未来利率下行影响，同时还有资产保全和传承的功能。险资自己的权益仓位都创了四年新高，说明聪明的机构资金也在转向长期稳健配置。当然这类产品流动性相对低，需要根据您的整体资产结构来评估合不合适。我能不能约个时间，为您做一个全面的资产诊断？',
    keyPoints: ['用利率下行趋势制造紧迫感', '突出增额终身寿"锁利"核心价值', '引用险资入市佐证长期价值', '以"诊断"替代"销售"，降低防御'],
  },
  {
    id: 's7',
    title: 'MLF续作后，向客户解释货币政策',
    scenario: '客户询问央行MLF操作对市场的影响',
    category: '宏观经济',
    script:
      '简单说，央行这次超量续作MLF，就是向市场多放了3000亿的"水"。这个动作传递了两个信号：第一，年底前流动性不会太紧，银行融资成本稳定，对债市是利好；第二，政策面继续呵护经济，对股市的中期情绪也有支撑。对您来说，最直接的影响是：固收产品的收益率短期内不会大幅上行，如果您手里有到期的理财，现在续作或者配置短期纯债基金，收益率虽然不高，但胜在稳定。等明年政策进一步明朗之后，我们再根据情况调整配置方向，您觉得怎么样？',
    keyPoints: ['用通俗语言解释专业概念，体现专业度', '把宏观信号翻译成客户的直接收益影响', '自然引导到产品配置建议'],
  },
  {
    id: 's8',
    title: '北向资金回流，引导客户关注A股机会',
    scenario: '外资净流入，客户对A股回暖持观望态度',
    category: '股市',
    script:
      '今天有一个值得关注的信号：北向资金时隔三日重现净买入，规模超50亿，主要流向科技和医药板块。外资的动向一向被市场视为风向标，他们在这个位置净买入，说明对A股中期基本面还是有信心的。当然，市场筑底不是一蹴而就的，短期仍有波动。我的建议是：如果您有闲置资金，可以考虑先小仓位布局沪深300指数ETF，参与市场反弹的同时控制风险。不需要一步到位，可以分两到三次建仓。您对这个方向有兴趣吗？',
    keyPoints: ['用外资动向制造信号感', '承认短期波动，不过度乐观', '提出具体可操作的建议（ETF+分批）', '以问句结尾，引导客户表达意向'],
  },
];
